import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

import { useKYC } from '@flipster/features/src/shared/kyc';
import CautionCircleIcon from '@flipster/react/icon/generated/CautionCircleIcon';
import { hstack } from '@flipster/styled-system/patterns';

export const KycWarning = () => {
  const { isRequireKyc, warningStatus } = useKYC();
  const transKyc = useTranslations('Kyc.r250804');

  const warning = useMemo(() => {
    if (warningStatus === 'Resubmit') return { text: transKyc('Resubmit_verification'), isCritical: false };
    if (warningStatus === 'TncAgreementRequired') return { text: transKyc('Agreement_required'), isCritical: true };
    if (isRequireKyc) return { text: transKyc('Verification_needed'), isCritical: false };
    return null;
  }, [isRequireKyc, warningStatus, transKyc]);

  if (!warning) return null;
  return (
    <div
      className={hstack({
        textStyle: 'Text/S/Regular',
        color: warning.isCritical ? 'content.state.negative' : 'content.state.warning',
        gap: 4,
      })}
    >
      <p>{warning.text}</p>
      <CautionCircleIcon size={16} />
    </div>
  );
};
